import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TEAMS_TRANSLATION } from '@modules/teams/constants';
import { PaginationResultsProps } from './PaginationResults.types';
import { Paragraph } from '@base-app/atoms';

const PaginationResults: FC<PaginationResultsProps> = ({ range, totalCount = 0 }) => {
  const { t } = useTranslation(TEAMS_TRANSLATION);
  const displayTotalCount = totalCount === 0 ? '' : `${t('of')} ${totalCount}`;
  return (
    <Paragraph css={{ fontSize: '$sm', fontWeight: '$medium' }} data-testid="pagination-results">
      {t('results')} {range[0]}-{range[1]} {displayTotalCount}
    </Paragraph>
  );
};

export default PaginationResults;
